import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegistrationPrompt = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: 'FileText',
      title: 'Professional Templates',
      description: 'Industry-standard credit formats for all film types'
    },
    {
      icon: 'Download',
      title: 'Multiple Export Formats',
      description: 'Export credits as video files in various resolutions'
    },
    {
      icon: 'Upload',
      title: 'Excel Integration',
      description: 'Import credits from spreadsheets with ease'
    },
    {
      icon: 'Zap',
      title: 'Fast Rendering',
      description: 'Generate professional credit sequences in minutes'
    }
  ];

  return (
    <div className="bg-muted/30 rounded-xl p-6 border border-border">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          New to RealRoll?
        </h3>
        <p className="text-sm text-muted-foreground">
          Join thousands of filmmakers creating professional credits
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name={benefit?.icon} size={16} className="text-primary" />
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground">
                {benefit?.title}
              </h4>
              <p className="text-xs text-muted-foreground mt-1">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <Button
        variant="outline"
        size="lg"
        fullWidth
        onClick={() => navigate('/user-registration')}
        iconName="UserPlus"
        iconPosition="left"
      >
        Create Free Account
      </Button>
      <p className="text-xs text-muted-foreground text-center mt-3">
        No credit card required • Start creating immediately
      </p>
    </div>
  );
};

export default RegistrationPrompt;